import React, {FC} from "react"
import {Wallet} from "@irati/types"
import {Row, Col} from "@irati/ui/src/Layout"

import {FormattedMessage} from "@irati/utils/lang"
import Spacing from "@irati/ui/src/Spacing"
import PointsRequestSection from "../../components/PointsRequests"
import Transactions from "../StatementItems/RewardWalletTransactions"
import {DesktopHeader} from "./styled"
import devToggles from "@irati/dev-toggles"
import useAuth from "@irati/auth/helpers/auth/useAuth"
import {H3} from "@irati/ui/src/Typography"

interface Props {
  wallet: Wallet
}

const RewardPoints: FC<Props> = ({wallet}) => {
  const auth = useAuth()
  const canSeePointsRequests =
    auth.productPermissions?.wallet?.canRequestPoints || auth.productPermissions?.wallet?.canApprovePointsRequest
  if (!Object.keys(wallet).length) {
    return null
  }

  return (
    <Row>
      <Col md={12}>
        {devToggles.showPointsRequest() && canSeePointsRequests && (
          <Spacing marginTop={4}>
            <PointsRequestSection />
          </Spacing>
        )}
        <Spacing marginTop={4}>
          {!devToggles.showPointsRequest() ? (
            <DesktopHeader marginBottom={2}>
              <FormattedMessage id="wallet.transactions.title.rewardPoints" />
            </DesktopHeader>
          ) : (
            <H3 marginBottom={2}>
              <FormattedMessage id="wallet.transactions.title.rewardPoints" />
            </H3>
          )}
          <Transactions walletId={wallet.uuid} />
        </Spacing>
      </Col>
    </Row>
  )
}

export default RewardPoints
